const PREVIEWABLE_FILETYPES = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
export const PREVIEW_PLACEHOLDER = 'assets/attachment_placeholder.png';
export default PREVIEWABLE_FILETYPES;
